module.exports = __webpack_public_path__ + "img/3Shape2.5702c020.png";